import { render, staticRenderFns } from "./PageWarrantyCard.vue?vue&type=template&id=3d7fd898&scoped=true"
import script from "./PageWarrantyCard.vue?vue&type=script&lang=js"
export * from "./PageWarrantyCard.vue?vue&type=script&lang=js"
import style0 from "./PageWarrantyCard.vue?vue&type=style&index=0&id=3d7fd898&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7fd898",
  null
  
)

export default component.exports